import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { saveStates, states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import {
  updateCohort, updateCohortProperties, updateCohortCancel, showSaveCohort,
} from '../actions';
import cohortDiff, { validateCohort } from '../helper';

const SaveCohortAction = ({
  cohort,
  disabled,
  exitEdit,
  saveStatus,
  code,
  category,
  update,
  updateProperties,
  saveCohort,
}) => {
  const isSaving = (saveStatus === states.PENDING);

  const setErrors = (newErrors) => (updateProperties(category, code, { saveErrors: newErrors }));

  const setStatus = (status) => (updateProperties(category, code, { saveStatus: status }));

  const proceedToSave = (cohortToSave) => {
    const validationErrors = validateCohort(cohortToSave);
    const hasErrors = validationErrors.length > 0;

    setErrors(validationErrors);
    if (hasErrors) {
      setStatus(states.ERROR);
    }

    return !hasErrors;
  };

  const submitForm = () => {
    setStatus(states.PENDING);

    const updates = cohortDiff(cohort);

    if (!updates) {
      exitEdit(category, code);
    } else if (proceedToSave(cohort)) {
      update(category, code, updates);
    }
  };

  const onSaveClick = () => {
    if (!cohort.isNew) {
      submitForm();
    } else if (proceedToSave({ queries: cohort.queries, isNew: true })) {
      saveCohort(category, code);
    }
  };

  return (
    <RibbonMenu
      name="save"
      icon="save"
      disabled={disabled}
      message="actions.save"
      onClick={onSaveClick}
      className="aridhia-save-cohort-action"
      loading={isSaving}
    />
  );
};

const mapStateToProps = ({
  cohorts: { cohorts },
}, { category, code }) => {
  const cohort = findResult(cohorts, category, code)
      || {
        ...saveStates,
        isDirty: false,
        isNew: false,
        queries: [],
      };

  return {
    disabled: cohort.queries.length === 0 || !cohort.isEditing || !cohort.isDirty,
    saveStatus: cohort.saveStatus,
    cohort,
  };
};

const mapDispatchToProps = {
  update: updateCohort,
  updateProperties: updateCohortProperties,
  exitEdit: updateCohortCancel,
  saveCohort: showSaveCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveCohortAction);
